<template lang="html">
  <div id="footer">
		<div class="flex-center-xy box-phrase">
			<div class="inside" >
				<h6 v-html="$root.extras.eslogan"></h6>
			</div>
		</div>

		<footer class="box-footer">
			<div class="container oversized-container">
				<div class="row flex-center-xy">
					<!-- <div class="col-lg col-footer col-logo">
						<img src="public/images/shared/join-corporativo.png">
					</div> -->

					<div class="col-lg col-footer col-text">
						<p>
							<a href="https://iobusco.com/" target="_blank" style="color: black;">Copyright Todos los derechos reservados IOBUSCO.COM S.A. de C.V. 2022</a>

						</p>
						<span style="color:#00cec8"><span class="aqual link-sm" @click="openedModal = 'aviso'" style="cursor:pointer;">Aviso de privacidad</span></span><br>
						<span style="color:#00cec8"><span class="aqual link-sm" @click="openedModal = 'terminos'" style="cursor:pointer;">Terminos y condiciones</span></span>
						<!-- <br>
						<div style="text-align: center;"><img src="https://jobusco.com/public/images/siem.png" style="width: 200px;"></div> -->
					</div>

					<div class="col-lg col-footer col-networks">
						<p>
							<a :href="$root.extras.facebook" target="_blank"><i class="fab fa-facebook-f"></i></a>
							<a :href="$root.extras.instagram" target="_blank"><i class="fab fa-instagram"></i></a>
						</p>
						<h5>Síguenos</h5>
					</div>

					<div class="col-lg col-footer col-app-info">
						<div class="row no-gutters">
							<div class="col-md col-image">
								<img src="public/images/shared/website-preview.jpg">
							</div>

							<div class="col-md col-info">
								<p>
									Recibe Notificaciones de vacantes.<br />
									Guarda posibles oportunidades.
								</p>
                <!-- <h5 class="mt-1">Descarga nuestra app</h5> -->
								<h5 class="mt-1 text-lg-center" style="line-height: 1.0; font-size: 25px;">Próximamente nueva actualización de nuestra App</h5>

								<!-- <div class="box-buttons">
									<a :href="$root.extras.appstore" target="_blank"><img src="public/images/shared/app-store.svg"></a>
									<a :href="$root.extras.googleplay" target="_blank"><img src="public/images/shared/google-play.svg"></a>
								</div> -->
							</div>
						</div>
					</div>
				</div>

			</div>

		</footer>
				<!-- Modal aviso de privacidad-->
    		<modalaviso-component></modalaviso-component>
    		<!--  -->
    		<!-- Modal terminos-->
    		<modalterminos-component></modalterminos-component>
    		<!--  -->
  </div>
</template>

<script>
import modalavisoComponent from './modals/modal-aviso-privacy.vue';
import modalterminosComponent  from './modals/modal-terminos.vue';
export default {
  data(){
    return{
      openedModal: null,
    }
  },


  components: {
   	modalavisoComponent,modalterminosComponent
  },

  mounted(){

  }
}
</script>
